import { IEnvironment } from '../types/IEnvironment';
import { InjectionToken } from '@angular/core';

export const ENVIRONMENT = new InjectionToken<IEnvironment>('ENVIRONMENT');
